import { DataLayerEvent } from "./events";

export { AdobeDataLayerService } from '@/adobe-data-layer-service';
export {
  ButtonClickEvent,
  CdpEvent, DecisionsDisplayedEvent, FormEvent,
  OneClickPurchaseEvent,
  PageErrorEvent,
  PageLoadedEvent,
  PageLoadStartedEvent,
  ProductLoadedEvent,
  UserDetectedEvent,
  VisitorIdEvent,
  WindowLoadedEvent,
  WindowLoadStartedEvent
} from '@/events';
export type { AlloyResponseDecision, AlloyResponsePropositions } from '@/events';

declare global {
  interface Window {
    adobeDataLayer: DataLayerEvent[];
  }
}